import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_BILLING_HISTORY = "billing_history";

export interface BillingRecord {
  id: number;
  user_id: string;
  package_id: string;
  plan_duration: string;
  trans_ref: string;
  packages: Package[] | null;
  package?: Package | null;
  corporate_id: string | null;
  status: "success" | "pending" | "failed";
  amount: number | string;
  currency: string;
  payment_gateway_id: number;
  payment_reference: string | null;
  upgrade: number;
  created_at: string;
  updated_at: string;
}

export interface Package {
  id: string;
  name: string;
  quarterly: string;
  enterprise_discount: number;
}

export interface BillingRecordDisplay extends BillingRecord {
  invoice_number: string;
  description: string;
  plan_name: string;
  invoice_url?: string;
  download_url?: string;
  date: string;
}

const getBillingHistory = async (token: string): Promise<BillingRecord[]> => {
  const url = `${END_POINT.BASE_URL}/v1/billing-history`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(url, config);

  if (response.data && Array.isArray(response.data)) {
    return response.data;
  }

  if (
    response.data &&
    response.data.data &&
    Array.isArray(response.data.data)
  ) {
    return response.data.data;
  }

  return [];
};

export const useGetBillingHistory = () => {
  const { token } = useGetUserInfo();

  const queryData = useQuery(
    [QUERY_KEY_FOR_BILLING_HISTORY],
    () => getBillingHistory(token),
    {
      enabled: !!token,
      retry: 1,
      onError: (err: any) => {
        console.error("Failed to fetch billing history:", err);
      },
      onSuccess: (data) => {
        console.log("Billing history fetched:", data);
      },
    },
  );

  return queryData;
};
